/* Créations Colibri : page d'accueil (maquette CRO v4 du 19/10/2026). Vidéos muettes en boucle, son de la vidéo de la nouvelle collection, flèches des rangées (ordinateur), horaire du jour à l'heure de Paris. */
(function () {
  var NOMS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  function icone(nom) { return '<svg class="ico" aria-hidden="true"><use href="#cca-i-' + nom + '"/></svg>'; }

  function videos(root) {
    root.querySelectorAll('video').forEach(function (v) {
      if (v.closest('[data-cca-son-actif]')) return;
      v.muted = true; v.loop = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  function son(root) {
    var b = root.querySelector('[data-cca-son]'); if (!b) return;
    var v = b.parentNode.querySelector('video'); if (!v) return;
    b.addEventListener('click', function () {
      v.muted = !v.muted;
      if (!v.muted) { v.volume = 1; v.play(); b.parentNode.setAttribute('data-cca-son-actif', ''); } else { b.parentNode.removeAttribute('data-cca-son-actif'); }
      b.innerHTML = v.muted ? icone('muet') + '<span>Activer le son</span>' : icone('son') + '<span>Couper le son</span>';
      b.setAttribute('aria-pressed', String(!v.muted));
    });
  }

  function curseur(root) {
    var c = root.querySelector('[data-cca-curseur]'); if (!c) return;
    var v = c.parentNode.querySelector('video'); if (!v) return;
    var glisse = false;
    function maj() {
      if (glisse || !v.duration) return;
      var p = v.currentTime / v.duration;
      c.value = Math.round(p * 1000); c.style.setProperty('--p', (p * 100).toFixed(1) + '%');
    }
    v.addEventListener('timeupdate', maj);
    c.addEventListener('input', function () {
      glisse = true;
      c.style.setProperty('--p', (c.value / 10).toFixed(1) + '%');
      if (v.duration) v.currentTime = c.value / 1000 * v.duration;
    });
    c.addEventListener('change', function () { glisse = false; var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); });
  }

  function ancres(root) {
    var haut = null;
    function surveiller() { if (window.scrollY < 300) cacher(); }
    function cacher() { if (haut) haut.classList.remove('visible'); window.removeEventListener('scroll', surveiller); }
    function bouton() {
      if (haut) return haut;
      haut = document.createElement('button');
      haut.type = 'button'; haut.className = 'cca-haut';
      haut.innerHTML = '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m18 15-6-6-6 6"/></svg><span>Revenir en haut</span>';
      haut.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); cacher(); });
      root.appendChild(haut);
      return haut;
    }
    root.querySelectorAll('a[href^="#cca-"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var cible = document.getElementById(a.getAttribute('href').slice(1)); if (!cible) return;
        e.preventDefault(); cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (!a.closest('.entete-video')) return;
        var b = bouton();
        setTimeout(function () { b.classList.add('visible'); window.addEventListener('scroll', surveiller, { passive: true }); }, 700);
      });
    });
  }

  function fleches(root) {
    var boutons = [].slice.call(root.querySelectorAll('[data-cca-defile]'));
    function maj(r) {
      boutons.forEach(function (b) {
        if (b.getAttribute('data-cca-defile') !== r.id) return;
        b.disabled = b.getAttribute('data-sens') === '-1' ? r.scrollLeft < 5 : r.scrollLeft + r.clientWidth > r.scrollWidth - 5;
      });
    }
    boutons.forEach(function (b) {
      var r = document.getElementById(b.getAttribute('data-cca-defile')); if (!r) return;
      b.addEventListener('click', function () { r.scrollBy({ left: (r.clientWidth + 18) * parseInt(b.getAttribute('data-sens'), 10) }); });
      if (!r.hasAttribute('data-cca-suivi')) {
        r.setAttribute('data-cca-suivi', '');
        r.addEventListener('scroll', function () { maj(r); }, { passive: true });
        window.addEventListener('resize', function () { maj(r); });
        maj(r);
      }
    });
  }

  function horaires(root) {
    var lignes = [].slice.call(root.querySelectorAll('[data-cca-horaires] [data-jours]'));
    if (!lignes.length) return;
    var H = {};
    lignes.forEach(function (l) { l.getAttribute('data-jours').split(',').forEach(function (j) { if (j !== '') H[j] = l.getAttribute('data-heures') || ''; }); });
    var j = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Paris' })).getDay();
    var rdv = function (h) { return /rdv/i.test(h || ''); };
    var carte = root.querySelector('[data-cca-jour]');
    if (carte) {
      carte.textContent = 'Aujourd’hui : ';
      var span = document.createElement('span'), h = H[j];
      if (h === undefined) {
        var k = j, n = 0;
        do { k = (k + 1) % 7; n++; } while ((H[k] === undefined || rdv(H[k])) && n < 7);
        span.className = 'ferme'; span.textContent = 'fermé'; carte.appendChild(span);
        if (H[k] !== undefined && !rdv(H[k])) {
          var debut = H[k].match(/\d{1,2}h\d{0,2}/);
          carte.appendChild(document.createTextNode(' · ouvert ' + NOMS[k] + (debut ? ' dès ' + debut[0] : '')));
        }
      } else {
        span.className = 'vert'; span.textContent = rdv(h) ? 'ouverte sur RDV' : h; carte.appendChild(span);
      }
    }
    lignes.forEach(function (l) {
      if (l.getAttribute('data-jours').split(',').indexOf(String(j)) > -1) {
        l.classList.add('auj');
        if (l.firstElementChild) l.firstElementChild.textContent += ' (aujourd’hui)';
      }
    });
  }

  function init(root) { videos(root); son(root); curseur(root); ancres(root); fleches(root); horaires(root); }
  function tout() { document.querySelectorAll('.cca').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.cca'); if (r) init(r); });
})();
